import { DataTable } from "primereact/datatable";
import React, { useRef, useState } from "react";
import Table from "./Table";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
export interface IModel {
  open: boolean;
}
const LegalTaskManagement = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ open: false } as IModel);
  const [reload, setReload] = useState(false);
  const toast = useRef<any>(null);
  return (
    <>
      <Table permissions={permissions} reload={reload} setModal={setModal} toast={toast}/>
      <Toast ref={toast} />
    </>
  );
};

export default LegalTaskManagement;
